import { dashboardHDLR } from "../../../handlers"

export const getColor = (value) => {
    if (value === 'RequestedAmount') return '#211572';
    if (value === 'NetDisbursementAmount') return '#821CB1';
    if (value === 'AdminFees') return '#5454C5';
    if (value === 'TotalApplications') return '#D10707';
    if (value === 'TotalApplicants') return '#FF0000';
    if (value === 'NewApplicants') return '#FFA800';
  }

  export const calculateTotals = (data) => {
    return data.reduce((totals, summary) => {
        totals.total_pr_reqAmount += summary.total_pr_reqAmount || 0;
        totals.total_pr_disbursed += summary.total_pr_disbursed || 0;
        totals.total_pr_fee += summary.total_pr_fee || 0;
        totals.total_pr_request += summary.total_pr_request || 0;
        totals.total_employee_applied += summary.total_employee_applied || 0;
        totals.total_employee_first_applied += summary.total_employee_first_applied || 0;
        return totals;
    }, {
        total_pr_reqAmount: 0,
        total_pr_disbursed: 0,
        total_pr_fee: 0,
        total_pr_request: 0,
        total_employee_applied: 0,
        total_employee_first_applied: 0,
    });
}

export const compData = (sum, companies) => 
    sum.reduce((acc, item) => {
    const { coid, total_pr_request} = item;

    if (!acc[coid]) {
        acc[coid] = { applied: 0, total_employee: 0, total_pr_request: 0 }; 
    }   
        acc[coid].applied += total_pr_request;   
        acc[coid].total_employee = companies[coid]?.detailEmployee?.active
        acc[coid].companyName = companies[coid]?.name
    return acc;
}, {});

export const empData = (sum) => 
    sum.reduce((acc, item) => {
    const { uid, applied } = item;

    if (!acc[uid]) {
        acc[uid] = { ...item, applied: 0}; 
    }   
        acc[uid].applied += applied;   
    return acc;
}, {});

const filterYears = (summaries, year) => {
    const yearString = year.toString().slice(-2);
    return summaries.filter(item => item.createdDate.toString().startsWith(yearString));
  };

export const monthlyGroupData = (summaries, selectedYear) => {
    return filterYears(summaries, selectedYear).map((monthly) => ({
        month: dashboardHDLR.formatMonth(monthly.createdDate),
        total_pr_disbursed: monthly.total_pr_disbursed,
        total_pr_fee: monthly.total_pr_fee,
        total_employee_activate: monthly.total_employee_activate,
        total_pr_request: monthly.total_pr_request,
    }));
}

export const monthlyChartData = (data) => {
    const aggregated = {};
  
    data.forEach((item) => {
      const { month, total_pr_disbursed, total_pr_fee, total_employee_activate, total_pr_request } = item;
      
      const monthName = month.split(' ')[0]; 

      if (!aggregated[monthName]) {
        aggregated[monthName] = {
          total_pr_disbursed: 0,
          total_pr_fee: 0,
          total_employee_activate: 0,
          total_pr_request: 0
        };
      }
  
      aggregated[monthName].total_pr_disbursed += total_pr_disbursed;
      aggregated[monthName].total_pr_fee += total_pr_fee;
      aggregated[monthName].total_employee_activate += total_employee_activate;
      aggregated[monthName].total_pr_request += total_pr_request;
    });
  
    return Object.keys(aggregated).map((monthName) => ({
      month: monthName,
      ...aggregated[monthName]
    }));
  }

export const resultDailyData = (data, disburse, fees, app, requested, appl, newAppl) => {
    // Step 1: Flatten the data into an array with all values
    const flattenedData = data.flatMap(item => {
        const { createdDate, total_pr_reqAmount, total_pr_disbursed, total_pr_fee, total_pr_request, total_pr_applicants = 0, total_pr_new_applicants = 0 } = item;
        
        const dateFormat = dashboardHDLR.formatDate(createdDate);

        return [
            disburse && { date: dateFormat, value: total_pr_disbursed, category: "Net Disbursement Amount" },
            fees && { date: dateFormat, value: total_pr_fee, category: "Admin Fees" },
            app && { date: dateFormat, value: total_pr_request, category: "Total Applications" },
            requested && { date: dateFormat, value: total_pr_reqAmount, category: "Requested Amount" },
            appl && { date: dateFormat, value: total_pr_applicants, category: "Total Applicants" },
            newAppl && { date: dateFormat, value: total_pr_new_applicants, category: "New Applicants" },
        ].filter(Boolean);
    });

    // Step 2: Group and sum values by date and category
    const aggregatedData = flattenedData.reduce((acc, { date, value, category }) => {
        const key = `${date}_${category}`;
        if (!acc[key]) {
            acc[key] = { date, category, value: 0 };
        }
        acc[key].value += value;
        return acc;
    }, {});

    // Convert aggregated data back to an array
    return Object.values(aggregatedData).filter(item => item.value !== 0);
}



// export const resultDailyData = (data, disburse, fees, app, requested, appl, newAppl) => {
//     return data.flatMap(item => {
//         const { createdDate, total_pr_reqAmount, total_pr_disbursed, total_pr_fee, total_pr_request, total_pr_applicants = 0, total_pr_new_applicants = 0 } = item;
        
//         const dateFormat = dashboardHDLR.formatDate(createdDate);

//         return [
//             disburse && { date: dateFormat, value: total_pr_disbursed, category: "Net Disbursement Amount" },
//             fees && { date: dateFormat, value: total_pr_fee, category: "Admin Fees" },
//             app && { date: dateFormat, value: total_pr_request, category: "Total Applications" },
//             requested && { date: dateFormat, value: total_pr_reqAmount, category: "Requested Amount" },
//             appl && { date: dateFormat, value: total_pr_applicants, category: "Total Applicants" },
//             newAppl && { date: dateFormat, value: total_pr_new_applicants, category: "New Applicants" },
//         ].filter(Boolean);
        
//     })
// }

export const resultEmployeesData = (data) => {
    return data.flatMap(profile => {
    const result = [];

    if (profile.Female) {
        Object.entries(profile.Female).forEach(([age, { reqAmount, count }]) => {
            result.push(
                { gender: "Female", age: parseInt(age), reqAmount: reqAmount, count: count },
                { gender: "Female", age: parseInt(age), reqAmount: reqAmount, count: count }
            );
        });
    }

    if (profile.Male) {
        Object.entries(profile.Male).forEach(([age, { reqAmount, count }]) => {
            result.push(
                { gender: "Male", age: parseInt(age), reqAmount: reqAmount, count: count },
                { gender: "Male", age: parseInt(age), reqAmount: reqAmount, count: count }
            );
        });
    }

    return result;
})
}